import React from 'react';

const Hero = () => {
  return (
    <div className="hero text-center" style={{padding: '40px 16px'}}>
      <h1 style={{fontSize: '2rem', fontWeight: '800'}}>Become a <span className="gold">Comparison Engine</span> Reseller</h1>
      <p className="text-muted" style={{marginTop: '16px'}}>Launch your own financial comparison business in minutes.</p>
    </div>
  );
};

export default Hero;
